import { render } from "./Club.vue?vue&type=template&id=6f6f55ee"
import script from "./Club.vue?vue&type=script&lang=js"
export * from "./Club.vue?vue&type=script&lang=js"

import "./Club.vue?vue&type=style&index=0&id=6f6f55ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__